var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { on: { click: _vm.showField } },
    [
      _vm.customField.field_type == "contacts"
        ? _c("div", { staticClass: "field-wrap" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c("div", { staticClass: "row mb-4" }, [
                _c("div", { staticClass: "contact-box" }, [
                  _c("h5", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.customField.name) +
                        "\n                "
                    ),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true }
                          }
                        ],
                        staticClass: "edit-contact-btn",
                        attrs: { title: "Edit contact", href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.updateContact(_vm.customField.id)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fas fa-edit" })]
                    )
                  ]),
                  _vm._v(" "),
                  _c("strong", [_vm._v(_vm._s(_vm.customField.company_name))]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.customField.phone))]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.customField.email_address))]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true }
                        }
                      ],
                      staticClass: "delete-contact-btn",
                      attrs: { title: "Remove contact", href: "#" },
                      on: {
                        click: function($event) {
                          return _vm.onShowRemoveContact(_vm.customField.id)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fas fa-trash-alt" })]
                  )
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Contact Removal",
            "ok-title": "Yes, Remove"
          },
          on: { ok: _vm.onConfirmRemoveContact },
          model: {
            value: _vm.showRemoveContact,
            callback: function($$v) {
              _vm.showRemoveContact = $$v
            },
            expression: "showRemoveContact"
          }
        },
        [_c("p", [_vm._v("Are you sure you want to unassign this contact?")])]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }